// extracted by mini-css-extract-plugin
module.exports = {"search":"mobileSearch_search__UC3Qx"};